import {Form as FormEntity} from "../Form";
import {SelectFieldWindow} from "./SelectFieldWindow";

import {t} from "../Translate";

export class LikertFieldWindow extends SelectFieldWindow {
	constructor(formEntity:FormEntity, type:string) {
		super(formEntity, type);

		this.selectOptions.value = [
			t("Strongly disagree"),
			t("Disagree"),
			t("Neutral"),
			t("Agree"),
			t("Strongly agree")
		];

	}
}